// @flow
import React from 'react';

type Props = {
    listing: {
        propertyType: string,
        geoDistance: {
            text: string,
            relationType: string
        } | null
    }
};

const PropertyDetails = ({listing}: Props) => {
    const {propertyType, geoDistance} = listing;
    const text = geoDistance ? geoDistance.text : '';

    return (
        <div className="HitInfo__type-place-details">
            {!!propertyType && <span>{propertyType}</span>}
            {!!text && <span>{text}</span>}
        </div>
    );
};

export default PropertyDetails;
